import { UserManager, UserManagerSettings, Log } from "oidc-client-ts";
import LoggingService from "./loggingService";
import { MessageType } from "../enums/messageType";

let instance: any;
let userManager: UserManager;
let userMangerSettings: UserManagerSettings;
let authorityUrl: string  = process.env.REACT_APP_CD_AUTHORITY!;
let appClientId: string = process.env.REACT_APP_CD_TEAMS_APP_CLIENT_ID!;
let appUrl: string = process.env.REACT_APP_URL!;

class AuthService {
    
    constructor() {
        if (instance) {
            throw new Error("You can only create one instance!");
        }

        Log.setLogger(console);
        Log.setLevel(Log.INFO);

        userMangerSettings = {
            authority: authorityUrl,
            client_id: appClientId,
            scope: "CarpeWebApi openid",
            response_type: "code",
            response_mode: "query",
            
            //redirect_uri: appUrl + "/index.html#/login",
            redirect_uri: appUrl + "/index.html#/login-callback",
            post_logout_redirect_uri: appUrl + "/index.html#/logout",

            popup_redirect_uri: appUrl + "/index.html#/popup-callback",
            popup_post_logout_redirect_uri: appUrl,

            silent_redirect_uri: appUrl + "/index.html#/silent-callback",
            automaticSilentRenew: false,

            validateSubOnSilentRenew: true,
            filterProtocolClaims: true,
            loadUserInfo: false,
            
            monitorAnonymousSession: true,
            revokeTokensOnSignout: true,
        };
        
        LoggingService.log(LoggingService.isLoggingEnabled() ? `AuthService - constructor - ${JSON.stringify(userMangerSettings)}` : '', MessageType.Info);
        userManager = new UserManager(userMangerSettings);

        instance = this;
    }

    getInstance() {
        return this;
    }

    userManager(){
        return userManager;
    }

    userMangerSettings(){
        return userMangerSettings;
    }
}
 
const authenticationService = Object.freeze(new AuthService());
export default authenticationService;
